import clsx from 'clsx';
import A from 'components/atoms/A/A';
import Card from 'components/atoms/Card/Card';
import BannerChevron from './assets/banner-chevron.svg';
import QmeePersonCompact from './assets/qmee-person-compact.svg';
import classes from './SurveysPageCompactProfiler.qmee.module.scss';
import { ProgressBar } from 'components/atoms/ProgressBar/ProgressBar';
import { useMoreSurveysBannerQuery_profileUrlRef$data } from './__generated__/useMoreSurveysBannerQuery_profileUrlRef.graphql';

export type Props = {
  data: useMoreSurveysBannerQuery_profileUrlRef$data;
  className: string;
};

export default function SurveysPageCompactProfiler({ data, className }: Props) {
  const percentageComplete = data.profileCompletionPercentage?.profileCompletionPercentage ?? 0;

  if (!data.endlessProfilerUrl) {
    return null;
  }

  const endlessProfilerVersionTwo = `${data.endlessProfilerUrl}&v2=true`;

  return (
    <Card className={clsx(classes.root, className)}>
      <A href={endlessProfilerVersionTwo} className={classes.innerLink}>
        <div className={clsx(classes.progressSection)}>
          <QmeePersonCompact className={classes.qmeePersonCompact} />
          <ProgressBar
            style="linear"
            value={percentageComplete}
            max={100}
            className={classes.progressBar}
          />
          <div className={classes.percentage}>
            <span>{percentageComplete}%</span>
            <BannerChevron className={classes.chevron} />
          </div>
        </div>
      </A>
    </Card>
  );
}
